import React from "react";

// Progress indicator shared by the subscription, integration, activation and
// deactivation modals.
export default function WizardSteps({ steps, index }) {
  return (
    <ol className="lud-app-steps" aria-label="steps">
      {steps.map((label, position) => (
        <li key={label} className={position === index ? "is-current" : position < index ? "is-done" : ""} aria-current={position === index ? "step" : undefined}>
          <span>{position + 1}</span>
          {label}
        </li>
      ))}
    </ol>
  );
}
